import type { ChatAttachmentUploadResponse } from '../../types/krybot';
import { KrybotService } from '../../services/api/krybotService';
import {
  uploadedAttachmentToRecord,
  type ChatPanelAttachmentRecord,
  type PendingChatAttachment,
} from './chatPanelAttachments';

export type UploadThreadAttachmentFn = (
  threadId: string,
  file: File,
  options: { userId: string; artifactItemRef?: string }
) => Promise<ChatAttachmentUploadResponse>;

export async function uploadPendingChatAttachments(
  threadId: string,
  pending: PendingChatAttachment[],
  options: { userId: string; artifactItemRef?: string },
  uploadFn: UploadThreadAttachmentFn = KrybotService.uploadThreadAttachment.bind(KrybotService)
): Promise<ChatPanelAttachmentRecord[]> {
  const uploaded: ChatPanelAttachmentRecord[] = [];
  for (const item of pending) {
    if (!item.file) {
      throw new Error(`Missing file payload for attachment "${item.name}"`);
    }
    const artifactItemRef = item.artifactItemRef ?? options.artifactItemRef;
    const response = await uploadFn(threadId, item.file, {
      userId: options.userId,
      ...(artifactItemRef ? { artifactItemRef } : {}),
    });
    uploaded.push(uploadedAttachmentToRecord(response));
  }
  return uploaded;
}
